import React, { createContext, useContext } from "react";

export const PromptInstructionsContext = createContext<any[]>([]);
export const usePromptInstructionsContext = () =>
  useContext(PromptInstructionsContext);
